<twc-popup type="primary" caption="{{'PERMISSION_DIALOG.PERMISSION_INHERITANCE' | translate}}" width="l"
    #inheritedPermPopup>
    <twc-popup-content>

        <div class="twc-form">
            <div class="twc-form-control">
                <label for="firstName" class="twc-form-label"> {{'PERMISSION_DIALOG.USER' | translate}} </label>
                <div class="twc-form-element">
                    <input class="twc-input" [ngModel]="permissionsUserName" [disabled]="true">
                </div>
            </div>
        </div>

        <div class="twc-row twc-mt-3 twc-ml-3" *ngIf="!inheritedGroupsPermList?.length; else inheritedLists">
            <div class="twc-col-12">
                {{ 'PERMISSION_DIALOG.NO_INHERIT_PERMISSIONS' | translate }}
            </div>
        </div>

        <ng-template #inheritedLists>
            <div class="twc-row twc-mt-3">
                <div class="twc-col-12">
                    <cw-permissions-list [list]="inheritedGroupsPermList" [isReadOnly]="true"></cw-permissions-list>
                </div>
            </div>

            <div class="twc-row twc-mt-4">
                <div class="twc-col-12">
                    {{ 'PERMISSION_DIALOG.DEFAULT_PERMISSIONS_INTRO' | translate }}
                </div>
            </div>
            <div class="twc-row twc-mt-1">
                <div class="twc-col-12">
                    <cw-permissions-list [list]="defaultValues" [isReadOnly]="true"></cw-permissions-list>
                </div>
            </div>
        </ng-template>

    </twc-popup-content>

    <twc-popup-footer class="twc-mt-3">
        <button class="twc-button twc-button-primary" (click)="closePopup()">
            {{'GENERAL.CLOSE' | translate}}
        </button>
    </twc-popup-footer>

</twc-popup>